import { IBookingNotes, IPaymentOption } from "./types";
import { ICustomer, IPaymentDetails, IPaymentPending, IPaymentSummary, PaymentTypes } from "app/app.types";
import { ISavedBookingSelectedOptions } from "shared-types/index";

/**
 * Populating booking notes
 */
export function MakeBookingNotes(bookingNotes: string, customerInfo: ICustomer): IBookingNotes {

  const notes: IBookingNotes = {
    bookingNotes: bookingNotes,
    customerNotes: GetStringValue(customerInfo.notes),
    managerNotes: GetStringValue(customerInfo.managerNotes)
  };

  return notes;
}

/**
 * Extract payment details
 */
export function GetPaymentDetails(paymentDetails: IPaymentDetails): IPaymentOption {

  let paymentInfo = {} as IPaymentOption;

  // Check whether valid payment details are provided
  if (!paymentDetails) return paymentInfo;
  if (paymentDetails.paymentType === PaymentTypes.NoPayment) return paymentInfo;

  paymentInfo = MakePaymentOptions(paymentDetails.paymentType, paymentDetails.price ? paymentDetails.price.toString() : null);
  return paymentInfo;
}

/**
 * Extract payment summary
 */
export function GetPaymentSummary(paymentSummary: IPaymentSummary, pendingPaymentInfo: IPaymentPending): IPaymentOption {

  let amount: string = '0';
  let paymentInfo = {} as IPaymentOption;

  // Check whether valid payment summary are provided
  if (!paymentSummary) return paymentInfo;

  const { paymentType, amountHeld, preAuthStatus, amountPaid, preAuthChargedAmount } = paymentSummary;
  if (paymentType === PaymentTypes.NoPayment) return paymentInfo;

  if (paymentType === PaymentTypes.PreAuth) {
    amount = preAuthStatus === "Holding" ? amountHeld : preAuthChargedAmount ? preAuthChargedAmount.toString() : null;
  }
  else {
    const nbiFee = pendingPaymentInfo ? pendingPaymentInfo.nbiFee : 0;
    amount = (amountPaid - nbiFee).toString();
  }

  paymentInfo = MakePaymentOptions(paymentSummary.paymentType, amount);
  return paymentInfo;
}

/**
 * Compute total number of lines occupied by the booking options
 */
export function ComputeLinesOccupiedByBookingOptions(bookingOptionList: ISavedBookingSelectedOptions[], isUpsell = false): number {

  // Do not proceed, when no booking options are provided
  if (!bookingOptionList || bookingOptionList.length === 0) return 0;

  const totalNumberOfLines = bookingOptionList.reduce((count,item) => {
    // Must've atleast one quantity
    if (item.quantity > 0 && item.isUpsellItem === isUpsell) {
      count = count + item.extras.length + 1;
    }
    return count;
  }, 0);

  return totalNumberOfLines;
}

/** Determines string type */
function GetStringValue(value: any) {
  return typeof value === 'string' ? value : null;
}

/**
 * Populating payment details
 */
function MakePaymentOptions(paymentType: PaymentTypes, amount: string): IPaymentOption {

  const paymentInfo: IPaymentOption = {
    paymentType: paymentType,
    price: amount || undefined
  }

  return paymentInfo;
}
